import { SyntheticEvent, useMemo, useState } from 'react';
import TabPanel from '@mui/lab/TabPanel';
import {
  mdiCardAccountDetailsOutline,
  mdiShimmer,
  mdiStoreOutline,
  mdiLink,
  mdiAccountGroup,
  // mdiCog,
  mdiInvoiceListOutline,
} from '@mdi/js';
import Icon from '@mdi/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseTabs, MobileTabs } from '../../components/base';
import {
  ProfileSettings,
  AppearanceSettings,
  PermissionSettings,
  ShopsSettings,
  BillingSettings,
  IntegrationSettings,
  // ShopConfiguration,
} from './components';
import { usePermissions } from '../../hooks/useCommon';

const SettingsTabs = () => {
  const { i18n, t } = useTranslation(['settings', 'inputs']);
  const { permissions } = usePermissions();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        label: t('profile'),
        value: '1',
        icon: <Icon path={mdiCardAccountDetailsOutline} size={1} />,
      },
      {
        label: t('appearance'),
        value: '2',
        icon: <Icon path={mdiShimmer} size={1} />,
      },
      {
        label: t('shops'),
        value: '3',
        icon: <Icon path={mdiStoreOutline} size={1} />,
      },
      // {
      //   label: 'Integrations',
      //   value: '4',
      //   icon: <Icon path={mdiLink} size={1} />,
      // },
    ];

    const adminTabs = [
      // {
      //   label: 'Shop configuration',
      //   value: '4',
      //   icon: <Icon path={mdiCog} size={1} />,
      // },
      {
        label: t('permissions', { ns: 'inputs' }),
        value: '5',
        icon: <Icon path={mdiAccountGroup} size={1} />,
      },
      {
        label: t('integrations'),
        value: '6',
        icon: <Icon path={mdiLink} size={1} />,
      },
      {
        label: t('billing'),
        value: '7',
        icon: <Icon path={mdiInvoiceListOutline} size={1} />,
      },
    ];

    if (permissions.isAdmin) {
      baseTabs.push(...adminTabs);
    }

    return baseTabs;
  }, [i18n.language, permissions]);

  const [value, setValue] = useState('1');
  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const TabsComponent = isMobile ? MobileTabs : BaseTabs;

  return (
    <TabsComponent
      tabs={tabs}
      value={value}
      centered={false}
      handleChange={handleChange}
      customStyle={{
        pt: 1,
        marginTop: { xs: 2 },
      }}
    >
      <TabPanel value="1" sx={{ px: 0 }}>
        <ProfileSettings />
      </TabPanel>
      <TabPanel value="2" sx={{ px: 0 }}>
        <AppearanceSettings />
      </TabPanel>
      <TabPanel value="3" sx={{ px: 0 }}>
        <ShopsSettings />
      </TabPanel>
      {/* <TabPanel value="4" sx={{ px: 0 }}> */}
      {/*  <ShopConfiguration /> */}
      {/* </TabPanel> */}
      <TabPanel value="5" sx={{ px: 0 }}>
        <PermissionSettings />
      </TabPanel>
      <TabPanel value="6" sx={{ px: 0 }}>
        <IntegrationSettings />
      </TabPanel>
      <TabPanel value="7" sx={{ px: 0 }}>
        <BillingSettings />
      </TabPanel>
    </TabsComponent>
  );
};

export {
  SettingsTabs,
};
